import React from "react";
import { List } from "../modules/CreditServiceStatements";

export function CreditServiceStatementsPage() {
  return <List />;
}
